import React from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';

import DashboardLayout from '../components/dashboard/DashboardLayout';
import ApplicantsTab from './ApplicantsTab';
import EmailLogTab from './EmailLogTab';
import FileUploadLogTab from './FileUploadLogTab';

// Tabbed Applicants area — pathname-based tabs (like CommissionsPage): each tab
// is its own path, so switching (navigate) clears the querystring, and each tab
// view guards its URL-sync effects on location.pathname to avoid cross-tab state
// leakage. Static tab segments (email-log / file-uploads) outrank the
// /applicants/:id detail route in React Router, so there's no collision.
export const APPLICANTS_PATH = '/applicants';
export const EMAIL_LOG_PATH = '/applicants/email-log';
export const FILE_UPLOAD_PATH = '/applicants/file-uploads';

const ApplicantsPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const tab =
    location.pathname === EMAIL_LOG_PATH ? 'email-log' : location.pathname === FILE_UPLOAD_PATH ? 'file-uploads' : 'applicants';

  const go = (k: string | null) => {
    if (!k) return;
    navigate(k === 'applicants' ? APPLICANTS_PATH : `${APPLICANTS_PATH}/${k}`);
  };

  return (
    <DashboardLayout title="Applicants" scrollable>
      <Tabs activeKey={tab} onSelect={go} mountOnEnter unmountOnExit>
        <Tab eventKey="applicants" title="Applicants">
          <ApplicantsTab />
        </Tab>
        <Tab eventKey="email-log" title="Email Log">
          <EmailLogTab />
        </Tab>
        <Tab eventKey="file-uploads" title="Documents">
          <FileUploadLogTab />
        </Tab>
      </Tabs>
    </DashboardLayout>
  );
};

export default ApplicantsPage;
